/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-07-04 19:51:36
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-07-23 19:36:23
 * @FilePath: /intl-pc-jdi-website-ssr/src/utils/thirdParty/gtag.ts
 * @Description: gtag所有相关方法 仅限客户端调用（gtagjs加载后才会有这些）
 */
import { isNextServer } from "@/utils/uaParser";
import cookieUtil from "@/utils/cookieUtils";

export function  getGASessionId() {
  const cookie = document.cookie.match('(^|;)\\s*_ga\\s*=\\s*([^;]+)');
  if (!cookie) return '';
    
  // _ga格式: GA1.2.XXXXXXXXXX.YYYYYYYYYY
  const parts = cookie[2].split('.');
  if (parts.length < 4) return '';
    
  // session_id通常是最后一部分时间戳
  return parts[3];
}

export function getGAClientId() {
  // gtag('get') 方式也可以获取，但是方法为异步，不如cookie获取方便
  const cookie = document.cookie.match('(^|;)\\s*_ga\\s*=\\s*([^;]+)');
  if (!cookie) return '';
  
  // 提取client_id（格式: GA1.2.XXXXXXXXXX.YYYYYYYYYY）
const parts = cookie[2].split('.');
  if (parts.length < 4) return '';
  
  return `${parts[2]}.${parts[3]}`;
}

/**
 * 设置Google Analytics用户ID
 * @param pin - 可选的用户标识符
 * 在所有获取用户信息的地方都可能被调用，因此需要判断server
 */
export function gtagSetUserId(pin: string) {
  if (!isNextServer() && window?.gtag && pin) {
    // 这个方式会覆盖config设置的其他值，慎用
    // window.gtag('config', 'G-QQWYJK15EP', {
    //   'user_id': pin,
    // });
    window.gtag('set', 'user_id', pin)
  }
}
  
  
export function gtagClearUserId() {
  // window?.gtag && window.gtag('config', 'G-QQWYJK15EP', {
  //   'user_id': null,
  // });
  window?.gtag && window.gtag('set', 'user_id', null); 
}

export function gtagAddCartLog(skuIds: number[] | string[]) {
  const _currency = cookieUtil.getCookie('_currency');
  window?.gtag && window.gtag("event", "add_to_cart", {
    currency: _currency,
    items: skuIds.map((id) => ({ item_id: id.toString() })),
  });
}
  
export function gtagCheckoutLog(value: number, skuIds: number[] | string[] ) {
  const _currency = cookieUtil.getCookie('_currency');
  window?.gtag && window.gtag("event", "add_payment_info", {
    currency: _currency,
    value,
    items: skuIds.map((id) => ({ item_id: id.toString() })),
  });
}
  
export function gtagPurchaseLog(orderId: string, value: number, skuIds?: number[] | string[]) {
  const _currency = cookieUtil.getCookie('_currency');
  window?.gtag && window.gtag("event", "purchase", {
    transaction_id: orderId,
    value,
    currency: _currency,
    items: skuIds?.map((id) => ({ item_id: id.toString() })) || [],
  });
}
  